<style lang="scss" scoped>
@import "@/styles/variables.scss";
.register {
    background: $secondary;
    height: 100vh;
    width: 100%;
    display: flex;
    overflow: auto;

    .logo {
        height: 60px;
        width: auto;
        margin-right: auto;
    }
}
.avatar-upload {
    position: relative;
    cursor: pointer;
    .profile-image {
        height: 60px;
        width: 60px;
        border-radius: 50%;
        cursor: pointer;
        object-fit: cover;
        background: #e3eaee;
        &:hover {
            border: 1px solid $secondary;
        }
    }
    input[type="file"] {
        opacity: 0;
        position: absolute;
        left: 0;
        top: 0;
        width: 100%;
        height: 100%;
        cursor: pointer;
    }
}
.tel-select {
    border-radius: $border-radius 0 0 $border-radius;
    border-color: $input-group-addon-border-color;
    background: $input-group-addon-bg;
    color: $secondary;
    &:focus {
        outline: none;
    }
    option {
        background: #fff;
    }
}
.vat-select {
    border-radius: $border-radius 0 0 $border-radius;
    border-color: $input-group-addon-border-color;
    background: $input-group-addon-bg;
    color: $secondary;
    padding: 0 10px;
    &:focus {
        outline: none;
    }
}
</style>

<template>
    <div class="register d-flex flex-wrap py-45">
        <box class="mx-auto mt-auto mb-30 col-12 col-md-8 col-lg-7" :padding="90">
            <template slot="content">
                <i-logo class="logo mb-45"></i-logo>

                <div v-if="error" class="fs-12 text-danger">
                    {{ error }}
                </div>

                <form v-if="step === 'profile'" data-vv-scope="profile" @submit.prevent="validateAndContinue" class="border-top pt-45">
                   <!--  <div class="form-row">
                        <div class="form-group col-md-6 mb-15">
                            <label class="avatar-upload" for="uploadPhotos">
                                <div class="profile-image d-flex" v-if="!new_image">
                                    <i-profile class="i-20 m-auto"></i-profile>
                                </div>
                                <img v-else class="profile-image" :src="new_image">
                                <input type="file" name="profilepicture" accept="image/*" @change="onFileChange">
                                <span class="text-secondary my-auto ml-15">Upload foto</span>
                            </label>
                        </div>
                    </div> -->
                    <!-- Firstname, Lastname -->
                    <div class="form-row">
                        <div class="form-group col-md-6">
                            <label for="firstname">
                                {{ $t('register.firstname') }}
                                <span class="ml-auto text-danger">{{ errors.first('profile.firstname') }}</span>
                            </label>
                            <input v-model="user.first_name" v-validate="'required'" name="firstname" type="text" class="form-control" id="firstname" :placeholder="$t('register.firstname')" :data-vv-as="$t('register.firstname')">
                        </div>
                        <div class="form-group col-md-6">
                            <label for="lastname">
                                {{ $t('register.lastname') }}
                                <span class="ml-auto text-danger">{{ errors.first('profile.lastname') }}</span>
                            </label>
                            <input v-model="user.last_name" v-validate="'required'" name="lastname" type="text" class="form-control" id="lastname" :placeholder="$t('register.lastname')" :data-vv-as="$t('register.lastname')">
                        </div>
                    </div>

                    <!-- Birthdate -->
                    <div class="form-row">
                        <div class="form-group col-md-6">
                            <label for="birthdate">
                                {{ $t('register.birthday') }}
                                <span class="ml-auto text-danger">{{ errors.first('profile.birthdate') }}</span>
                            </label>
                            <datepicker v-model="user.birthday" v-validate="'required'" :open-date="new Date(dateBefore)" :disabledDates="{ from: new Date(dateBefore) }" format="dd/MM/yyyy" type="date" name="birthdate" input-class="form-control bg-white" id="birthdate" :placeholder="$t('register.birthday')" :data-vv-as="$t('register.birthdate')"></datepicker>
                        </div>
                    </div>

                    <!-- Email, Phone -->
                    <div class="form-row">
                        <div class="form-group col-md-6">
                            <label for="email">
                                {{ $t('register.email') }}
                                <span class="ml-auto text-danger">{{ errors.first('profile.email') }}</span>
                            </label>
                            <input v-model="user.email" v-validate="'required|email|email_exists'" data-vv-delay="500" name="email" type="email" class="form-control" id="email" :placeholder="$t('register.email')" :data-vv-as="$t('register.email')">
                        </div>
                        <div class="form-group col-md-6">
                            <label for="phone">
                                {{ $t('register.phone') }}
                                <span class="ml-auto text-danger">{{ errors.first('profile.phone') }}</span>
                            </label>
                            <div class="input-group mb-3">
                                <div class="input-group-prepend">
                                    <select class="tel-select" v-model="cellphonePrefix">
                                        <option v-for="country in getCountriesByDialCode()" :value="country.dialCode" :selected="country.dialCode === cellphonePrefix">{{ country.dialCode }}</option>
                                    </select>
                                </div>
                                <input type="text" class="form-control" v-model="cellphone" v-validate="'required|numeric'" name="phone" id="phone" :placeholder="$t('register.phone')" :data-vv-as="$t('register.phone')">
                            </div>
                        </div>
                    </div>

                    <!-- Email, Phone -->
                    <div class="form-row">
                        <div class="form-group col-md-6">
                            <label for="password">
                                {{ $t('register.password') }}
                                <span class="ml-auto text-danger">{{ errors.first('profile.password') }}</span>
                            </label>
                            <input v-model="user.password" v-validate="'required|min:8'" name="password" type="password" class="form-control" id="password" :placeholder="$t('register.password')" :data-vv-as="$t('register.password')" ref="password">
                        </div>
                        <div class="form-group col-md-6">
                            <label for="repeatPassword">
                                {{ $t('register.repeatpassword') }}
                                <span class="ml-auto text-danger">{{ errors.first('profile.repeat-password') }}</span>
                            </label>
                            <input v-validate="'required|confirmed:password'" name="repeat-password" type="password" class="form-control" id="repeatPassword" :placeholder="$t('register.repeatpassword')" :data-vv-as="$t('register.password')">
                        </div>
                    </div>

                    <div class="form-row mt-15">
                        <div class="form-group col-12 mb-0">
                            <button class="btn btn-primary">{{ $t('bin.next') }}</button>
                        </div>
                    </div>
                </form>

                <form v-if="step === 'company'" data-vv-scope="company" @submit.prevent="submit" class="border-top pt-45">
                    <!-- Company, Vat -->
                    <div class="form-row">
                        <div class="form-group col-md-6">
                            <label for="vat">
                                {{ $t('register.company.vat') }}
                                <span class="ml-auto text-danger">{{ errors.first('company.vat') }}</span>
                            </label>
                            <div class="input-group mb-3">
                                <div class="input-group-prepend">
                                    <select class="vat-select" v-model="vatPrefix">
                                        <option v-for="country in getCountriesByCountryCode()" :value="country.code" :selected="country.code === vatPrefix">{{ country.code }}</option>
                                    </select>
                                </div>
                                <input v-model="vat" v-validate="'required|alpha_num'" name="vat" type="text" class="form-control" id="vat" :placeholder="$t('register.company.vat')" :data-vv-as="$t('register.company.vat')">
                            </div>
                        </div>

                        <div class="form-group col-md-6">
                            <label for="company">
                                {{ $t('register.company.company') }}
                                <span class="ml-auto text-danger">{{ errors.first('company.company') }}</span>
                            </label>
                            <input v-model="user.company.name" v-validate="'required'" disabled name="company" type="text" class="form-control" id="company" :placeholder="$t('register.company.company')" :data-vv-as="$t('register.company.company')">
                        </div>
                    </div>

                    <div class="form-row mt-15 mb-15">
                        <div class="form-group col-12 mb-30 d-flex">
                            
                            <div class="d-flex flex-row">
                                <span class="btn btn-light fw-semi-bold text-secondary" @click.prevent="validateAndCheckCompany" v-if="!loading">{{ $t('register.check') }}</span>
                                <loader class="" v-if="loading"></loader>
                            </div>
                            <div class="ml-15">
                                <div class="text-danger fs-12 px-30" v-if="company_exists" v-html="$t('register.company_exists')"></div>
                                <div class="text-danger fs-12 px-30" v-if="company_doesnotexist" v-html="$t('register.company_doesnotexist')"></div>
                            </div>
                        </div>
                    </div>

                    <div v-if="!validCompany" class="form-row mb-30">
                        <div class="form-group col-10">
                            <label for="vat">
                                {{ $t('register.company.address.street') }}
                                <span class="ml-auto text-danger">{{ errors.first('company.street') }}</span>
                            </label>
                            <input v-model="user.company.address.street" v-validate="'required'" name="street" type="text" class="form-control" id="street" :placeholder="$t('register.company.address.street')" :data-vv-as="$t('register.company.address.street')">
                        </div>
                        <div class="form-group col-2">
                            <label for="vat">
                                &nbsp;
                                <span class="ml-auto text-danger">{{ errors.first('company.number') }}</span>
                            </label>
                            <input v-model="user.company.address.number" v-validate="'required'" name="number" type="text" class="form-control" id="number" placeholder="nr" :data-vv-as="$t('register.company.address.number')">
                        </div>
                        <div class="form-group col-3">
                            <label for="vat">
                                {{ $t('register.company.address.zip') }}
                                <span class="ml-auto text-danger">{{ errors.first('company.zip') }}</span>
                            </label>
                            <input v-model="user.company.address.zip" v-validate="'required'" name="zip" type="text" class="form-control" id="zip" :placeholder="$t('register.company.address.zip')" :data-vv-as="$t('register.company.address.zip')">
                        </div>
                        <div class="form-group col-4">
                            <label for="vat">
                                {{ $t('register.company.address.city') }}
                                <span class="ml-auto text-danger">{{ errors.first('company.city') }}</span>
                            </label>
                            <input v-model="user.company.address.city" v-validate="'required'" name="city" type="text" class="form-control" id="city" :placeholder="$t('register.company.address.city')" :data-vv-as="$t('register.company.address.city')">
                        </div>
                        <div class="form-group col-5">
                            <label for="vat">
                                {{ $t('register.company.address.country') }}
                                <span class="ml-auto text-danger">{{ errors.first('company.country') }}</span>
                            </label>

                            <select v-validate="'required'" name="country" class="form-control" id="country" v-model="user.company.address.country" :data-vv-as="$t('register.company.address.country')">
                                <option v-for="country in getCountriesByCountryCode()" :value="country.code" :selected="country.code === user.company.address.country">{{ country.name }}</option>
                            </select>
                        </div>
                    </div>

                    <div class="custom-control custom-checkbox mb-45">
                        <input v-model="user.terms" type="checkbox" name="terms" v-validate="'required'" class="custom-control-input" id="aggreedTerms" :data-vv-as="$t('bin.tos')">
                        <label class="custom-control-label fs-16 fw-normal text-secondary" for="aggreedTerms" v-html="$t('register.agreeterms')"></label>
                        <span class="ml-30 text-danger fs-12 text-right">{{ errors.first('company.terms') }}</span>
                    </div>

                    <div class="form-row mt-15">
                        <div class="form-group col-12 mb-0">
                            <span class="btn btn-light mr-15" @click="step = 'profile'">{{ $t('bin.previous') }}</span>
                            <button class="btn btn-primary" :disabled="validCompany">{{ $t('register.register') }}</button>
                        </div>
                    </div>
                </form>
            </template>
        </box>

        <div class="mx-auto mb-auto col-12 text-center text-white">{{ $t('register.haveaccount') }}
            <router-link class="text-white" :to="{ name: 'login' }">{{ $t('register.login') }}</router-link>.    
        </div>
    </div>
</template>


<script>
import { mapActions } from "vuex";
import "vue-tel-input/dist/vue-tel-input.css";
import axios from "axios";
import Datepicker from "vuejs-datepicker";

export default {
    name: "register",
    components: { Datepicker },
    data() {
        return {
            step: "profile",
            vat: "",
            vatPrefix: "BE",
            cellphone: "",
            cellphonePrefix: "+32",
            user: {
                image: "",
                first_name: "",
                last_name: "",
                birthday: "",
                email: "",
                cellphone: "",
                password: "",
                language: "",
                company: {
                    vat: "",
                    name: "",
                    email: "",
                    address: {
                        street: "",
                        zip: "",
                        city: "",
                        number: "",
                        country: ""
                    }
                }
            },
            company_exists: false,
            company_doesnotexist: false,
            company_checked: false,
            company_found: false,
            new_image: false,
            dateBefore: this.$moment()
                .subtract(18, "Y")
                .format("YYYY-MM-DD"),
            error: "",
            loading: false
        };
    },
    methods: {
        ...mapActions(["register", "checkCompany", "login"]),

        validateAndContinue() {
            this.$validator.validateAll(this.step).then(res => {
                if (res) {
                    this.step = "company";
                }
            });
        },

        http(access_token) {
            return axios.create({
                baseURL: process.env.VUE_APP_API_URL,
                headers: {
                    Accept: "application/json",
                    "Content-Type": "application/json",
                    "Api-Version": process.env.VUE_APP_API_VERSION,
                    "Accept-Language": this.$i18n.locale,
                    Authorization: "Bearer " + access_token
                }
            });
        },

        /*  
        | -----------------------
        | Handle event when a new profile image was uploaded
        | -----------------------
        */
        onFileChange(event) {
            let self = this;
            if (event.target.files && event.target.files[0]) {
                var reader = new FileReader();

                reader.onload = function(e) {
                    self.new_image = e.target.result;
                    self.user.image = self.new_image;
                };

                reader.readAsDataURL(event.target.files[0]);
            }
        },

        /*  
        | -----------------------
        | Handle register form submit
        | -----------------------
        */
        submit() {
            this.$validator.validateAll(this.step).then(res => {
                if (res) {
                    this.getClientTokenPromise()
                        .then(result => {
                            this.user.cellphone =
                                this.cellphonePrefix +
                                this.cellphone.replace(/\s/g, "");
                            this.user.birthday = this.$moment(this.user.birthday).format('YYYY-MM-DD');
                            this.user.address = this.user.company.address;
                            this.user.company.email = this.user.email;
                            return this.http(result.data.access_token).post(
                                "/api/user",
                                this.user
                            );
                        })
                        .then(resp => {
                            // login user
                            return this.login(this.user);
                        })
                        .then(() => {
                            this.$router.push("/");
                        })
                        .catch(error => {                            
                            this.error = error.response.data.error_description;
                            this.$toasted.show(error.response.data[0].message);
                        });
                }
            });
        },

        validateAndCheckCompany() {
            this.$validator.validate(`${this.step}.vat`).then(res => {
                if (res) {
                    this.checkCompany()
                }
            });    
        },

        getClientTokenPromise() {
            let request = this.$http.post("/oauth/access_token", {
                grant_type: "client_credentials",
                client_id: process.env.VUE_APP_CLIENT_ID,
                client_secret: process.env.VUE_APP_CLIENT_SECRET,
                scope: "app"
            });

            return request;
        },

        checkCompanyPromise(response) {
            return this.http(response.data.access_token).get(
                "/api/company?vat=" + this.vatPrefix + this.vat
            );
        },

        /*  
        | -----------------------
        | Set the company address
        | -----------------------
        */
        setAddress(address) {
            this.user.company.address.street = address.street;
            this.user.company.address.number = address.number;
            this.user.company.address.city = address.city;
            this.user.company.address.country = address.country;
            this.user.company.address.zip = address.zip;
        },

        /*  
        | -----------------------
        | Check if a company exists or not
        | -----------------------
        */
        checkCompany() {
            this.loading = true;
            this.getClientTokenPromise()
                .then(result => {
                    return this.checkCompanyPromise(result);
                })
                .then(newresult => {
                    // 1. Parse result
                    let company = newresult.data;
                    // 2. Flag that we have checked for the company
                    this.company_checked = true;
                    // 3. Clear the previous company data
                    this.user.company.name = "";
                    this.user.company.vat = "";
                    this.setAddress({
                        street: "",
                        zip: "",
                        city: "",
                        number: "",
                        country: this.vatPrefix
                    });
                    if (company.hasOwnProperty("id")) {
                        this.user.company.name = company.name;
                        this.user.company.vat = company.vat;
                        this.company_exists = true;
                        this.company_found = true;
                        this.company_doesnotexist = false;
                        this.setAddress(company.address);
                    } else if (company.hasOwnProperty("name")) {
                        this.company_exists = false;
                        this.company_found = true;
                        this.user.company.name = company.name;
                        this.user.company.vat = company.vat;
                        this.company_doesnotexist = false;
                        if (company.address) this.setAddress(company.address);
                    }
                    this.loading = false;
                })
                .catch(error => {      
                    this.loading = false;             

                    if (error.response && error.response.status === 503 && Array.isArray(error.response.data) && error.response.data.length > 0 && error.response.data[0].hasOwnProperty('message')) {
                        this.$toasted.show(error.response.data[0].message);
                    }
                    
                    this.user.company.name = "";
                    this.user.company.vat = "";
                    this.company_exists = false;
                    this.company_found = false;
                    this.company_doesnotexist = true;
                    this.setAddress({
                        street: "",
                        zip: "",
                        city: "",
                        number: "",
                        country: ""
                    });
                });
        }
    },
    computed: {
        validCompany() {
            return !(!this.company_exists && this.company_found);
        }
    }
};
</script>
